const activateLicense2 = /* GraphQL */ `
  mutation activateLicense2($id: String!, $accountId: String!, $attributes: [LicenseAttributeInput]) {
    activateLicense2(id: $id, attributes: $attributes) {
      licensable {
        id
        type
        customerId
        ... on SelectableCourseLicenseList {
          courses {
            courseSku
            courseName(accountId: $accountId)
          }
        }
      }
      statusCode
      reason {
        key
        value
      }
    }
  }
`;

export default activateLicense2;
